import dayjs, { ConfigType } from "dayjs";
import duration from "dayjs/plugin/duration";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import localeData from "dayjs/plugin/localeData";
import localizedFormat from "dayjs/plugin/localizedFormat";
import minMaxPlugin from "dayjs/plugin/minMax";
import relativeTime from "dayjs/plugin/relativeTime";
import utc from "dayjs/plugin/utc";

dayjs.extend(localizedFormat);
dayjs.extend(localeData);
dayjs.extend(utc);
dayjs.extend(isSameOrAfter);
dayjs.extend(minMaxPlugin);
dayjs.extend(relativeTime);
dayjs.extend(duration);

export { dayjs };
export type DateInput = ConfigType;
